export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-19.d7fcb14e.svg";